import { z } from 'zod';

export const UploadDocumentsResultSchema = z.object({
  file_id: z.string(),
  type: z.string(),
  url: z.string().nullable(),
});

export type UploadDocumentsResult = z.infer<typeof UploadDocumentsResultSchema>;

// Use FormData for file upload (matching original project)
export type UploadDocumentsParams = FormData;
